<div class="">
    <div class="header-menu_mobile fixed-top">
        <div class="container">
            <nav class="navbar navbar-expand-lg navbar-light">
                <a class="navbar-brand " routerLink="">
                    <img src="../../../assets/images/Logo.jpg" alt="Logo toyosa" class="py-2 logo"/>
                </a>
                <button class="w-10 navbar-toggler mx-3" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation" (click)="viewMenuPrincipal()">
                    <span class="navbar-toggler-icon"></span>
                </button>
            </nav>
        </div>
        
        <div class="menu-principal" *ngIf="menuPrincipal">
            <ul class="nav flex-column f-roboto fs-4 pt-2 pb-4">
                <li class="nav-item pb-2">
                    <a class="nav-link" routerLink="" (click)="noViewMenuPrincipal()">Inicio</a>
                </li>
                <li class="nav-item pb-2" ngbDropdown>
                    <a class="nav-link" (click)="isCollapsedPostVenta = !isCollapsedPostVenta" [attr.aria-expanded]="!isCollapsedPostVenta" ngbDropdownToggle aria-controls="collapsePostVenta">
                        Camiones
                    </a>
                    <div class="ps-4" id="collapsePostVenta" [ngbCollapse]="!isCollapsedPostVenta">
                        <ul class="nav flex-column pl-3">
                            <li *ngFor="let items of modelos"><a [routerLink]="items.modelo_url" class="dropdown-item color-red py-3 text-uppercase f-hino ps-4 fs-5" (click)="noViewMenuPrincipal()">{{items.nombre_modelo}}</a></li>
                        </ul>
                    </div>
                </li>
                
                <li class="nav-item pb-2">
                    <a class="nav-link" routerLink="cotizar" (click)="noViewMenuPrincipal()">Cotizador</a>
                </li>
                <li class="nav-item pb-2">
                    <a class="nav-link" routerLink="sobre-nosotros" (click)="noViewMenuPrincipal()">Sobre Nosotros</a>
                </li>
                <li class="nav-item pb-2">
                    <a class="nav-link" routerLink="sucursales" (click)="noViewMenuPrincipal()">Sucursales</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="contactenos" (click)="noViewMenuPrincipal()">Contacto</a>
                </li>
            </ul>    
        </div>
    </div>
</div>